import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

export interface ProfileListCard {
	name?: string;
	profilePicURL?: string;
	progress?: number;
	contactInfo?: Array<any>;
	shortInfo?: Array<any>;
	date?: string;
  completedPercent?: string;
  completionDate?: string;
  scoredPercentage?: any;
}

@Component({
  selector: 'app-profile-list-card',
  templateUrl: './profile-list-card.component.html',
  styleUrls: ['./profile-list-card.component.scss']
})
export class ProfileListCardComponent implements OnInit {

  @Input('record') ProfileListCard: ProfileListCard;
	@Output() detail: any = new EventEmitter();
  @Input('assessmentScore') assessmentScore : any;
  @Input('completionDate') completionDate : any;
  @Input('scormData') scormData : any;
  constructor(public locale: LocaleService,
		public gfService: GlobalFunctionService) { }

  ngOnInit(): void {
    // console.log(this.ProfileListCard, 'profilelistCard>>>>>')
  }

}
